class AccordionQuickLinks {
  constructor() {
    this.container = document.querySelector('.accordion-quick-links');
    if (!this.container) return;

    this.quickLinks = this.container.querySelectorAll('.accordion-quick-link');
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    this.quickLinks.forEach(link => {
      link.addEventListener('click', this.handleQuickLinkClick.bind(this));
    });
  }

  handleQuickLinkClick(event) {
    event.preventDefault(); // Prevent default link behavior
    const link = event.currentTarget;
    const accordionId = link.dataset.accordionId;
    const scrollId = link.dataset.scrollId;
    const accordionHeading = link.dataset.accordionHeading;
    const rowId = link.dataset.rowId;
    
    // Add loading state
    link.classList.add('accordion-quick-link--loading');
    
    // Find the accordion element
    let targetAccordion = null;
    
    // Try to find by scroll ID first (if provided)
    if (scrollId) {
      targetAccordion = document.getElementById(scrollId);
    }
    
    // Fallback to accordion ID (for collapsible_tab blocks)
    if (!targetAccordion && accordionId) {
      targetAccordion = document.getElementById(accordionId);
    }
    
    // For collapsible_row blocks, find by heading text
    if (!targetAccordion && accordionHeading) {
      const accordions = document.querySelectorAll('.accordion');
      for (const accordion of accordions) {
        const titleElement = accordion.querySelector('.accordion__title');
        if (titleElement) {
          const titleText = titleElement.textContent.trim();
          const headingText = accordionHeading.trim();
          
          // Special case: "Features" in data matches "Description" in display
          if ((headingText.includes('Features') && titleText === 'Description') ||
              titleText === headingText) {
            targetAccordion = accordion;
            break;
          }
        }
      }
    }
    
    if (targetAccordion) {
      // If it's a details element, open it
      if (targetAccordion.tagName.toLowerCase() === 'details') {
        targetAccordion.open = true;
      } else {
        // If it's a container with details inside, find and open the details
        const detailsElement = targetAccordion.querySelector('details');
        if (detailsElement) {
          detailsElement.open = true;
        }
      }
      
      // Smooth scroll to the accordion
      this.scrollToAccordion(targetAccordion, link);
    } else {
      console.warn('Could not find accordion with heading:', accordionHeading || accordionId || scrollId);
      link.classList.remove('accordion-quick-link--loading');
    }
  }

  scrollToAccordion(accordion, link) {
    // Calculate offset (account for sticky headers, etc.)
    const offset = 80; // Adjust this value based on your header height
    
    const accordionTop = accordion.getBoundingClientRect().top + window.pageYOffset;
    const scrollToPosition = accordionTop - offset;
    
    // Smooth scroll
    window.scrollTo({
      top: scrollToPosition,
      behavior: 'smooth'
    });
    
    // Remove loading state after scroll animation
    setTimeout(() => {
      link.classList.remove('accordion-quick-link--loading');
      
      // Add a subtle highlight animation to the opened accordion
      this.highlightAccordion(accordion);
    }, 600);
  }

  highlightAccordion(accordion) {
    // Add highlight class
    accordion.classList.add('accordion--highlighted');
    
    // Remove highlight class after animation
    setTimeout(() => {
      accordion.classList.remove('accordion--highlighted');
    }, 2000);
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  window.accordionQuickLinks = new AccordionQuickLinks();
});

// Also initialize if script loads after DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.accordionQuickLinks = new AccordionQuickLinks();
  });
} else {
  window.accordionQuickLinks = new AccordionQuickLinks();
}